// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/swipe-action/style/index.less
// module id = 131
// module chunks = 0